webpackJsonp([31],{

/***/ 1001:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action-sidebar',{attrs:{"title":"Asignar Integración","value":true},on:{"close-modal":_vm.closeModal}},[_c('div',{staticClass:"px-3 pt-4"},[_c('v-flex',{attrs:{"xs12":"","mb-4":""}},[(_vm.openEdiType)?_c('v-select',{staticClass:"body-1",attrs:{"background-color":"white","box":"","disabled":_vm.disabledEdit,"hide-details":"","item-text":"name","item-value":"name","label":"Tipo de Integración","items":_vm.typeIntegration,"return-object":""},on:{"input":_vm.setValueTypeIntegration},model:{value:(_vm.process.typeIntegration),callback:function ($$v) {_vm.$set(_vm.process, "typeIntegration", $$v)},expression:"process.typeIntegration"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-4":""}},[_c('v-select',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","item-text":"name","item-value":"name","label":"Categorías","items":_vm.categories,"return-object":"","disabled":_vm.disabledEdit},on:{"input":_vm.setValueCategory},model:{value:(_vm.process.category),callback:function ($$v) {_vm.$set(_vm.process, "category", $$v)},expression:"process.category"}}),_vm._v(" "),(!_vm.$v.process.category.required)?_c('span',{staticClass:"form-group__message"},[_vm._v("\n\t\t\t\tEste campo es requerido.\n\t\t\t")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-4":""}},[_c('v-select',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","item-text":"name","item-value":"name","label":"Integración","items":_vm.integrations,"disabled":_vm.disabledEdit,"return-object":""},model:{value:(_vm.process.integration),callback:function ($$v) {_vm.$set(_vm.process, "integration", $$v)},expression:"process.integration"}}),_vm._v(" "),(!_vm.$v.process.integration.required)?_c('span',{staticClass:"form-group__message"},[_vm._v("\n\t\t\t\tEste campo es requerido.\n\t\t\t")]):_vm._e()],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs9":"","mb-4":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","placeholder":"0.00","hide-details":"","label":"Precio","type":"number"},model:{value:(_vm.process.price),callback:function ($$v) {_vm.$set(_vm.process, "price", $$v)},expression:"process.price"}}),_vm._v(" "),(!_vm.$v.process.price.required)?_c('span',{staticClass:"form-group__message"},[_vm._v("\n\t\t\t\t\tEste campo es requerido.\n\t\t\t\t")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","ml-4":""}},[_c('v-btn',{attrs:{"disabled":_vm.$v.$invalid,"color":"primary"},on:{"click":_vm.assignIntegration}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.titleButton)+"\n\t\t\t\t\t"),_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),(_vm.cancelEdit)?_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{attrs:{"color":"error"},on:{"click":_vm.cancelEditIntegration}},[_vm._v("\n\t\t\t\t\tCancelar\n\t\t\t\t")])],1):_vm._e()],1),_vm._v(" "),_c('app-table',{staticClass:"mt-2",attrs:{"name":"table-process-integration","columns":_vm.columns,"rows":_vm.rows,"input-search":false},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v(_vm._s(props.row.categoryName))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v(_vm._s(props.row.name))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}]},[_vm._v(_vm._s(props.row.price))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 4)),expression:"showRow(columns, 4)"}]},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('app-tooltip-button',{attrs:{"color":"green","icon":"edit","text":"Editar"},on:{"click-icon":function($event){_vm.editIntegration(props.row)}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('app-tooltip-button',{attrs:{"color":"error","icon":"delete","text":"Elimimar"},on:{"click-icon":function($event){_vm.openDialog(props.row)}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-switch',{staticClass:"ml-3 mt-0",attrs:{"slot":"activator","hide-details":""},on:{"change":function($event){_vm.activeSwitch(props.row)}},slot:"activator",model:{value:(props.row.flagDefault),callback:function ($$v) {_vm.$set(props.row, "flagDefault", $$v)},expression:"props.row.flagDefault"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.labelActive(props.row.flagDefault)))])],1)],1)],1)],1)]}}])}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500"},model:{value:(_vm.dialogIntegration),callback:function ($$v) {_vm.dialogIntegration=$$v},expression:"dialogIntegration"}},[_c('v-card',[_c('v-card-title',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.dialogMessage))]),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"btn-action",attrs:{"color":"green","dark":""},nativeOn:{"click":function($event){return _vm.deleteIntegration($event)}}},[_vm._v("\n\t\t\t\t\t\tSI\n\t\t\t\t\t")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-action",attrs:{"color":"error","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog($event)}}},[_vm._v("\n\t\t\t\t\t\tNO\n\t\t\t\t\t")])],1)],1)],1),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"is-loading":false,"success-text":"Guardar"},on:{"accept-button-clicked":_vm.saveProcess,"cancel-button-clicked":_vm.closeModal}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 512:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_configuration_process_assign_vue__ = __webpack_require__(822);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cf2d4d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_configuration_process_assign_vue__ = __webpack_require__(1001);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_configuration_process_assign_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cf2d4d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_configuration_process_assign_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(544));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(543));

var _alphaNum = _interopRequireDefault(__webpack_require__(546));

var _numeric = _interopRequireDefault(__webpack_require__(547));

var _between = _interopRequireDefault(__webpack_require__(548));

var _email = _interopRequireDefault(__webpack_require__(549));

var _ipAddress = _interopRequireDefault(__webpack_require__(550));

var _macAddress = _interopRequireDefault(__webpack_require__(551));

var _maxLength = _interopRequireDefault(__webpack_require__(552));

var _minLength = _interopRequireDefault(__webpack_require__(553));

var _required = _interopRequireDefault(__webpack_require__(554));

var _requiredIf = _interopRequireDefault(__webpack_require__(555));

var _requiredUnless = _interopRequireDefault(__webpack_require__(556));

var _sameAs = _interopRequireDefault(__webpack_require__(557));

var _url = _interopRequireDefault(__webpack_require__(558));

var _or = _interopRequireDefault(__webpack_require__(559));

var _and = _interopRequireDefault(__webpack_require__(560));

var _not = _interopRequireDefault(__webpack_require__(561));

var _minValue = _interopRequireDefault(__webpack_require__(562));

var _maxValue = _interopRequireDefault(__webpack_require__(563));

var _integer = _interopRequireDefault(__webpack_require__(564));

var _decimal = _interopRequireDefault(__webpack_require__(565));

var helpers = _interopRequireWildcard(__webpack_require__(541));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","APP_CODE":'ACL001',"APP_NAME":'"ACL"',"QUIPU_URL":'undefined',"MOCK_URL":'https://jsonplaceholder.typicode.com',"ACL_URL":'https://acl.casamarketapp.com/api',"SALES_URL":'https://sales.apprunn.net',"ACL_URL_COMPANY":'https://midecommerce.casamarketapp.com',"STORAGE_USER_KEY":"acl","S3_IMAGES_URL":'//s3.amazonaws.com/apprunn-acl',"COMPANY_LOGIN_TITLE":'ACL',"COMPANY_LOGIN_BACKGROUND":'https://s3.amazonaws.com/apprunn-acl/bg-login.jpg',"ACCEPT_SERVICE_V2":'application/vnd.apiacl.v2+json'}).BUILD === 'web' ? __webpack_require__(545).withParams : __webpack_require__(152).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73)))

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.withParams)({
  type: 'required'
}, _common.req);

exports.default = _default;

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.regex)('integer', /^-?[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 822:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_app_tooltip_button__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_action_sidebar__ = __webpack_require__(149);



var loadListCategories = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var idTemplate, headers, _ref2, response;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						idTemplate = this.$route.params.id;
						headers = {
							Accept: 'application/vnd.apiacl.v2+json'
						};
						_context.next = 4;
						return this.$http.get('template/' + idTemplate, { headers: headers });

					case 4:
						_ref2 = _context.sent;
						response = _ref2.data;

						if (response.data.integrations) {
							this.rows = response.data.integrations.integrations || [];
						} else {
							this.showError('Usted no tiene configurado este proceso.');
						}

					case 7:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadListCategories() {
		return _ref.apply(this, arguments);
	};
}();

var saveProcess = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var body;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						body = {
							integrations: this.rows.map(function (p) {
								var newOjb = {};
								newOjb.price = p.price;
								newOjb.flagDefault = p.flagDefault;
								newOjb.id = p.id;
								return newOjb;
							}),
							templateCode: this.$route.params.codeTemplate
						};
						_context2.prev = 1;
						_context2.next = 4;
						return this.$http.patch('integrations-template', body);

					case 4:
						this.showNotification('La Integración fue asignada correctamente.');
						this.clearForm();
						this.closeModal();
						_context2.next = 12;
						break;

					case 9:
						_context2.prev = 9;
						_context2.t0 = _context2['catch'](1);

						this.showError();

					case 12:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[1, 9]]);
	}));

	return function saveProcess() {
		return _ref3.apply(this, arguments);
	};
}();

var loadTypeIntegration = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						_context3.prev = 0;
						_context3.next = 3;
						return this.$http.get('type-integrations');

					case 3:
						response = _context3.sent;

						this.typeIntegration = response.data.data;
						if (this.typeIntegration.length === 1) {
							this.process.typeIntegration = this.typeIntegration[0];
							this.loadCategories(this.typeIntegration[0].id);
						}
						_context3.next = 11;
						break;

					case 8:
						_context3.prev = 8;
						_context3.t0 = _context3['catch'](0);

						this.showError();

					case 11:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[0, 8]]);
	}));

	return function loadTypeIntegration() {
		return _ref4.apply(this, arguments);
	};
}();

var loadCategories = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(id) {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						params = {
							typeIntegrationId: id
						};
						_context4.prev = 1;
						_context4.next = 4;
						return this.$http.get('categories', { params: params });

					case 4:
						response = _context4.sent;

						this.categories = response.data.data;
						if (this.categories.length === 1) {
							this.process.category = this.categories[0];
							this.loadIntegration(this.categories[0].id);
						}
						_context4.next = 12;
						break;

					case 9:
						_context4.prev = 9;
						_context4.t0 = _context4['catch'](1);

						this.showError();

					case 12:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this, [[1, 9]]);
	}));

	return function loadCategories(_x) {
		return _ref5.apply(this, arguments);
	};
}();

var loadIntegration = function () {
	var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(id) {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
			while (1) {
				switch (_context5.prev = _context5.next) {
					case 0:
						params = {
							categoryId: id
						};
						_context5.prev = 1;
						_context5.next = 4;
						return this.$http.get('integrations', { params: params });

					case 4:
						response = _context5.sent;

						this.integrations = response.data.data;
						if (this.integrations.length === 1) {
							this.process.integration = this.integrations[0];
						}
						_context5.next = 12;
						break;

					case 9:
						_context5.prev = 9;
						_context5.t0 = _context5['catch'](1);

						this.showError();

					case 12:
					case 'end':
						return _context5.stop();
				}
			}
		}, _callee5, this, [[1, 9]]);
	}));

	return function loadIntegration(_x2) {
		return _ref6.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





function created() {
	this.loadTypeIntegration();
	this.loadListCategories();
}

function activeSwitch(row) {
	if (row.flagDefault) {
		var categories = this.rows.some(function (r) {
			return r.categoryId === row.categoryId && r.flagDefault && r.id !== row.id;
		});
		if (categories) {
			var index = this.rows.findIndex(function (p) {
				return p.categoryId === row.categoryId;
			});
			if (index > -1) {
				this.rows[index].flagDefault = false;
			}
			this.showError('Solo se debe activar uno por categoria.');
		}
	}
}

function labelActive(value) {
	return value ? 'Activar Integración' : 'Desactivar Integración';
}

function assignIntegration() {
	var _this = this;

	var newobj = {
		idRow: this.process.id || this.rows.length + 1,
		id: this.process.integration.id,
		idCategory: this.process.category.id,
		categoryName: this.process.category.name,
		typeIntegration: this.process.typeIntegration,
		idTypeIntegration: this.process.typeIntegration.id,
		name: this.process.integration.name,
		price: this.process.price,
		flagDefault: false
	};
	if (this.process.id) {
		var indexId = this.rows.findIndex(function (r) {
			return r.id === _this.process.id;
		});
		if (indexId > -1) {
			this.rows[indexId].price = newobj.price;
			this.titleButton = 'Asignar';
		}
	} else {
		var index = this.rows.findIndex(function (r) {
			return r.id === _this.process.integration.id;
		});
		if (index > -1) {
			this.showError('Ya tiene asignado esta categoria.');
		} else {
			this.rows.push(newobj);
		}
	}
	this.cancelEdit = false;
	this.clearForm();
}

function clearForm() {
	this.process = {
		typeIntegration: '',
		category: '',
		integration: '',
		price: null
	};
	this.disabledEdit = false;
	this.openEdiType = true;
}

function disabled() {
	return this.rows.length === 0;
}

function closeModal() {
	this.goTo('page-configuration-process');
}

function editIntegration(row) {
	this.process.id = row.id;
	this.process.category = row.categoryName;
	this.process.price = row.price;
	this.process.integration = row.name;
	this.openEdiType = false;
	this.disabledEdit = true;
	this.cancelEdit = true;
	this.titleButton = 'Actualizar';
}

function openDialog(row) {
	this.dialogMessage = '\xBFDesea eliminar la integraci\xF3n \'' + row.name + '\' ?';
	this.idIntegration = row.id;
	this.dialogIntegration = true;
}

function closeDialog() {
	this.dialogMessage = '';
	this.dialogIntegration = false;
	this.idIntegration = null;
}

function deleteIntegration() {
	var _this2 = this;

	var indexIntegration = this.rows.findIndex(function (r) {
		return r.id === _this2.idIntegration;
	});
	if (indexIntegration > -1) {
		this.rows.splice(indexIntegration, 1);
		this.showNotification('La integración fue eliminada correctamente.');
		this.closeDialog();
	}
}

function setValueTypeIntegration(item) {
	this.loadCategories(item.id);
}

function setValueCategory(row) {
	this.loadIntegration(row.id);
	if (row.id === 1) {
		this.process.price = 0;
	}
}

function cancelEditIntegration() {
	this.process = {
		typeIntegration: '',
		category: '',
		integration: '',
		price: null
	};
	this.titleButton = 'Asignar';
	this.disabledEdit = false;
	this.openEdiType = true;
	this.cancelEdit = false;
}

function validations() {
	return {
		process: {
			category: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
			integration: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
			price: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] }
		}
	};
}

function data() {
	return {
		titleButton: 'Asignar',
		cancelEdit: false,
		categories: [],
		columns: [{ id: 1, name: 'Categoria', value: 'category', checked: true, visible: true }, { id: 2, name: 'Integración', value: 'type', checked: true, visible: true }, { id: 3, name: 'Precio', value: 'price', checked: true, visible: true }, { id: 4, name: 'Acciones', checked: true, visible: true }],
		dialogMessage: '',
		dialogIntegration: false,
		disabledEdit: false,
		integrations: [],
		rows: [],
		openEdiType: true,
		process: {
			typeIntegration: '',
			category: '',
			integration: '',
			price: null
		},
		typeIntegration: []
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-configuration-process-assign',
	data: data,
	created: created,
	components: {
		appTooltipButton: __WEBPACK_IMPORTED_MODULE_2__components_shared_app_tooltip_button__["a" /* default */],
		actionSidebar: __WEBPACK_IMPORTED_MODULE_4__components_shared_action_sidebar__["default"]
	},
	computed: {
		disabled: disabled
	},
	methods: {
		activeSwitch: activeSwitch,
		assignIntegration: assignIntegration,
		cancelEditIntegration: cancelEditIntegration,
		closeDialog: closeDialog,
		closeModal: closeModal,
		clearForm: clearForm,
		deleteIntegration: deleteIntegration,
		editIntegration: editIntegration,
		labelActive: labelActive,
		loadCategories: loadCategories,
		loadIntegration: loadIntegration,
		loadListCategories: loadListCategories,
		loadTypeIntegration: loadTypeIntegration,
		openDialog: openDialog,
		saveProcess: saveProcess,
		setValueTypeIntegration: setValueTypeIntegration,
		setValueCategory: setValueCategory
	},
	validations: validations
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/31.3b4aa2504c0291226b21.js